var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section is-fullheight"},[_c('admin-section-header',{attrs:{"icon":"bell","title":"Notificaciones"}}),_c('SectionUnderDevelopment',{attrs:{"text":"No tiene notificaciones"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }